import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["emailToggle", "mobileToggle", "emailCheckbox", "mobileCheckbox"]

  connect() {
    this.submitting = false
    this.pendingSubmit = false
    this.boundSubmitEnd = this.submitEnd.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
    this.syncToggles()
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  toggleEmail() {
    this.setAll(this.emailCheckboxTargets, this.emailToggleTarget.checked)
    this.submit()
  }

  toggleMobile() {
    this.setAll(this.mobileCheckboxTargets, this.mobileToggleTarget.checked)
    this.submit()
  }

  checkboxChanged() {
    this.syncToggles()
    this.submit()
  }

  syncToggles() {
    if (this.hasEmailToggleTarget) {
      this.syncToggle(this.emailToggleTarget, this.emailCheckboxTargets)
    }
    if (this.hasMobileToggleTarget) {
      this.syncToggle(this.mobileToggleTarget, this.mobileCheckboxTargets)
    }
  }

  syncToggle(toggle, checkboxes) {
    toggle.checked = checkboxes.length > 0 && checkboxes.every((checkbox) => checkbox.checked)
  }

  setAll(checkboxes, checked) {
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }

  // Stimulus 1.x has no values API; use data-auto-submit="false" to opt out (e.g. wizard Finish flow).
  autoSubmitEnabled() {
    return this.element.dataset.autoSubmit !== "false"
  }

  submit() {
    if (!this.autoSubmitEnabled()) return

    if (this.submitting) {
      this.pendingSubmit = true
      return
    }

    this.submitting = true
    this.pendingSubmit = false
    this.element.requestSubmit()
  }

  submitEnd() {
    this.submitting = false

    if (this.pendingSubmit) {
      this.submit()
    }
  }
}
